import React, { useState, useEffect } from 'react'
import { FormGroup, FormControl, Form, Button } from "react-bootstrap";
import Select from 'react-select'
import moment from 'moment'
import { addBusiness, editBusiness, uploadBusinessImage } from '../../../Services/business.service';
import _ from 'lodash';
import { getCategories } from '../../../Services/category.service';
import IConstants from '../../../Services/constants.service';
import Geocode from "react-geocode";

Geocode.setApiKey(IConstants.googleMapsAPIKey);

const AdminAddBusiness = (props) => {

  const [categoriesList, setCategoriesList] = useState([])
  const [bizHours, setBizHours] = useState("")
  const [socialMediaObj, setSocialMediaObj] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [businessImage, setBusinessImage] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false)
  const [name, setName] = useState('')
  const [keywords, setKeywords] = useState('')
  const [address, setAddress] = useState('')
  const [latitude, setLatitude] = useState('')
  const [longitude, setLongitude] = useState('')
  const [city, setCity] = useState('')
  const [website, setWebsite] = useState('')
  const [phoneNumer, setPhoneNumber] = useState('')
  const [mail,setEmail] = useState('')
  const [category, setCategory] = useState('')
  const [businessHours, setBusinessHours] = useState([])
  const [socialMedia, setSocialMedia] = useState([])
  const [description, setDescription] = useState('')
  const [status, setStatus] = useState(true);
  const [data, setData] = useState({
    address: '',
    businessHours: [],
    businessId: "",
    category: "",
    city: "",
    coverPhotoURL: "",
    description: "",
    keywords: "",
    logoURL: "",
    name: "",
    phoneNumber: "",
    registeredDate: moment().format("llll"),
    socialMedia: [],
    status: true,
    updatedDate: moment().format("llll"),
    website: ""
  })

  useEffect(() => {
    getAllCategories();
    if (!!props.businessData) {
      setName(props.businessData.name)
      setKeywords(props.businessData.keywords)
      setCity(props.businessData.city)
      setWebsite(props.businessData.website)
      setCategory(props.businessData.category)
      setBusinessHours(props.businessData.businessHours)
      setSocialMedia(props.businessData.socialMedia)
      setDescription(props.businessData.description)
      setStatus(props.businessData.status)
      setAddress(props.businessData.address)

    }
  }, []);

  console.log("=====",businessHours);

  let getAllCategories = () => {
    getCategories().then(resp => {
      setCategoriesList(resp)
    })
  }

  let handleChange = (event, type) => {

    if (type == "businessHours") {
      // let _data = data;
      if (!!bizHours) {
        if (!!bizHours.days && !!bizHours.to && !!bizHours.from) {

          let _hours = businessHours ? businessHours : []
          _hours.push(bizHours)
          setBusinessHours(_hours)
          // _data.businessHours = _hours
          // console.log('data', _data);
          // setData(_data);
          setBizHours("")
        }
      }
    }
    else if (type == "socialMedia") {
      console.log("socialMedia", socialMediaObj);
      if (!!socialMediaObj) {
        if (!!socialMediaObj.media && !!socialMediaObj.url) {

          let _sm = socialMedia ? socialMedia : []
          _sm.push(socialMediaObj)
          setSocialMedia(_sm)
          // let _data = data;
          // let _sm = [];
          // _sm = data.socialMedia ? data.socialMedia : []
          // _sm.push(socialMedia)
          // _data.socialMedia = _sm
          // setData(_data);
          setSocialMediaObj("")
        }
      }
    }
    else if (type == "status") {
      if (event.target.value == "true") {
        setStatus(true)
        console.log("here for true, ", status);
      }
      else {
        setStatus(false)
        console.log("here for false, ", status);
      }
    }
    else {
      let _data = data;
      _data[event.target.name] = event.target.value;
      setData(_data);
      console.log('data', data);
    }
  }

  function handleChangehours(e, type) {
    let _biz = bizHours ? bizHours : {};

    if (type == "days") {
      _biz.days = e.target.value
      setBizHours(_biz)
    }
    if (type == "from") {
      _biz.from = e.target.value
      setBizHours(_biz)
    }
    if (type == "to") {
      _biz.to = e.target.value
      setBizHours(_biz);
    }

  }

  function handleChangeMedia(e, type) {
    let _sm = socialMediaObj ? socialMediaObj : {};

    if (type == "socialMedia") {
      _sm.media = e.target.value
      setSocialMediaObj(_sm)
    }
    if (type == "socialMediaUrl") {
      _sm.url = e.target.value
      setSocialMediaObj(_sm)
    }

  }

  function uploadToFirebase(file) {
    return new Promise((resolve, reject) => {
      uploadBusinessImage(file).then((resp) => {
        resolve(resp);
      })

    })
  };


  async function handleSubmit(event) {
    event.preventDefault();
    const answer = window.confirm("are you sure?");
    if (answer) {
      setIsSubmit(true)
      let coverUrl;
      let logoUrl;
      if (!!coverImage) {
        coverUrl = await uploadToFirebase(coverImage)
      }
      if (!!businessImage) {
        logoUrl = await uploadToFirebase(businessImage)
      }
      let _data = {};
      // _data.logoURL = coverUrl
      // _data.coverPhotoURL = logoUrl

      // setData(_data);
      if (bizHours.length==0)
      {
      
      }else{
        setBusinessHours(businessHours.push(bizHours));
      }

      _data = {
        address: address,
        latitude: latitude,
        longitude: longitude,
        businessHours: businessHours,
        businessId: props.businessData ? props.businessData.businessId : '',
        category: category,
        city: city,
        coverPhotoURL: coverUrl ? coverUrl : props.businessData?.coverPhotoURL ? props.businessData?.coverPhotoURL : '',
        description: description,
        keywords: keywords,
        logoURL: logoUrl ? logoUrl : props.businessData.logoURL ? props.businessData.logoURL : '',
        name: name,
        phoneNumber: "",
        registeredDate: props.businessData ? props.businessData.registeredDate : moment().format("llll"),
        socialMedia: socialMedia,
        status: status,
        updatedDate: moment().format("llll"),
        website: website
      }

      console.log('before sending data', _data);

      if (!!props.businessData) {
        editBusiness(_data).then((resp) => {
          setIsSubmit(false)
          props.setHandleClose()
        })
      }
      else {
        addBusiness(_data).then((resp) => {
          setIsSubmit(false)
          console.log("props", props);
          props.setHandleClose()
        })
      }
    }

  }

  function onImageChange(e, type) {
    const reader = new FileReader();
    let file = e.target.files[0]; // get the supplied file
    // if there is a file, set image to that file
    if (file) {
      reader.onload = () => {
        if (reader.readyState === 2) {
          console.log(file);
          if (type == 'cover') {
            setCoverImage(file)
          }
          else {
            setBusinessImage(file)
          }

        }
      };
      reader.readAsDataURL(e.target.files[0]);
      // if there is no file, set image back to null
    } else {
      if (type == 'cover') {
        setCoverImage(null)
      }
      else {
        setBusinessImage(null)
      }
    }
  };

  function deleteItem(index, type) {
    console.log(index, type);
    if (type == 'hours') {
      console.log('before update', businessHours);
      let _biz = businessHours
      let updatedBiz = _.filter(_biz, (b, i) => {
        console.log(i, index);
        return i != index;
      });

      let _hours = [];
      _hours = updatedBiz ? updatedBiz : []
      setBusinessHours(_hours)

    }
    else {
      if (type == 'media') {
        console.log('before update', socialMedia);
        let _sm = socialMedia
        let updatedSM = _.filter(_sm, (b, i) => {
          console.log(i, index);
          return i != index;
        });

        let _hours = [];
        _hours = updatedSM ? updatedSM : []
        setSocialMedia(_hours)

      }
    }
  }

  let getLatLng = (value) => {
    setAddress(value)
    // Get latitude & longitude from address.
    console.log("address", value);
    Geocode.fromAddress(value).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        console.log("lat & lng", lat, lng);
        setLatitude(lat)
        setLongitude(lng)
      },
      (error) => {
        console.error(error);
      }
    );
  }


  return (
    <>
      <div className='d-flex align-items-center mb-5'>
        <div className='flex-1 container'>
          <div className="addBusinessDiv ">


            <form className='' onSubmit={handleSubmit}>

              <span className='bold-semifont para mt-4 dib'>PRIMARY LISTING DETAILS</span>
              <div className='app-border-full'></div>

              <div className="form-group">
                <span className='bold-semifont paraListing'>Business Name*</span>
                <input className="form-control" placeholder="XYZ Fabric" name="name" type="text" onChange={(e) => setName(e.target.value)} value={name}></input>
              </div>

              <div className="form-group">
                <span className='bold-semifont paraListing'>Keywords*</span>
                <input className="form-control" placeholder="Keyword should be separated by commas" name="keywords" type="text" onChange={(e) => setKeywords(e.target.value)} value={keywords}></input>
              </div>
              <div className="form-group">
                <span className='bold-semifont paraListing'>Full Address*</span>
                <input className="form-control" placeholder="Add address here" name="address" type="text" onChange={(e) => getLatLng(e.target.value)} value={address}></input>
              </div>
              <div className="form-group">
                <span className='bold-semifont paraListing'>Town/City*</span>
                <input className="form-control" placeholder="Add address here" name="city" type="text" onChange={(e) => setCity(e.target.value)} value={city}></input>
              </div>
              <div className="form-group">
                <span className='bold-semifont paraListing'>Phone Number*</span>
                <input className="form-control" placeholder="Add phone number here" name="phoneNumber" type="number" onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumer}></input>
              </div>
              <div className="form-group">
                <span className='bold-semifont paraListing'>Email*</span>
                <input className="form-control" placeholder="Add email address here" name="emailAddress" type="email" onChange={(e) => setEmail(e.target.value)} value={mail}></input>
              </div>
              {/* <div className="form-group">
                <span className='bold-semifont paraListing'>(Town/City)*</span>
                <input className="form-control" placeholder="Add address here" name="website" type="text" onChange={(e) => setWebsite(e.target.value)} value={website}></input>
              </div> */}
              <div className="form-group">
                <span className='bold-semifont paraListing'>Website</span>
                <input className="form-control" placeholder="Add address here" name="website" type="text" onChange={(e) => setWebsite(e.target.value)} value={website}></input>
              </div>


              <span className='bold-semifont para mt-5 dib'>CATEGORY & SERVICES</span>
              <div className='app-border-full'></div>

              <div className="form-group">
                <span className='bold-semifont paraListing'>Category*</span>
                <select className="form-control" placeholder="Add Category here" onChange={(e) => setCategory(e.target.value)} name="category" value={category} aria-label="Default select example">
                  <option value="">Select Type</option>
                  {categoriesList.map((item) => {
                    return (
                      <option value={item.categoryId} selected={item.categoryId == category}>{item.name}</option>
                    )
                  })}
                </select>
              </div>


              {/* Business hours */}
              <span className='bold-semifont para mt-5 dib'>BUSINESS HOURS</span>
              <div className='app-border-full'></div>
              {/* <div>
              <span>Facebook</span>
              <span>ahsaniqbal426</span>
              <span className="mb-3 col-auto"><i class="fa fa-plus addSocialLinkBtn"></i></span>
              </div> */}

              {businessHours?.length > 0 ?
                businessHours.map((b, index) => {
                  return (
                    <>
                      <div className="row ai-center" key={index}>
                        <div className="form-group col-auto pr-0">
                          <select className="form-control" style={{ textTransform: 'capitalize' }} placeholder="Day" disabled name="days" value={b.days} aria-label="Default select example">
                            <option value={b.days}>{b.days}</option>
                          </select>
                        </div>
                        <div className="form-group col-auto pr-0">
                          <select className="form-control" placeholder="Day" disabled name="days" value={b.from} aria-label="Default select example">
                            <option value={b.from}>{b.from}</option>
                          </select>
                        </div>

                        <div className="form-group col-auto pr-0">
                          <select className="form-control" placeholder="Day" disabled name="days" value={b.to} aria-label="Default select example">
                            <option value={b.to}>{b.to}</option>
                          </select>
                        </div>
                        <span className="mb-3 col d-flex jcE" onClick={() => deleteItem(index, 'hours')}><i className="fa fa-trash" aria-hidden="true"></i></span>

                      </div>
                    </>

                  )
                })
                : null}

              <div className="row ai-center">

                <div className="form-group col-auto pr-0">
                  <select className="form-control" placeholder="Day" onChange={(e) => handleChangehours(e, "days")} name="days" value={bizHours.days} aria-label="Default select example">
                    <option>Day</option>
                    <option value="monday">Monday</option>
                    <option value="tuesday">Tuesday</option>
                    <option value="wednesday">Wednesday</option>
                    <option value="thursday">Thursday</option>
                    <option value="friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                    <option value="Sunday">Sunday</option>
                  </select>
                </div>
                <div className="form-group col-auto pr-0">
                  <select className="form-control" placeholder="From" onChange={(e) => handleChangehours(e, "from")} name="from" value={bizHours.from} aria-label="Default select example">
                    <option>Opening</option>
                    <option value="12: 00 AM">12:00 AM</option>
                    <option value="01: 00 AM">01:00 AM</option>
                    <option value="02: 00 AM">02:00 AM</option>
                    <option value="03: 00 AM">03:00 AM</option>
                    <option value="04: 00 AM">04:00 AM</option>
                    <option value="05: 00 AM">05:00 AM</option>
                    <option value="06: 00 AM">06:00 AM</option>
                    <option value="07: 00 AM">07:00 AM</option>
                    <option value="08: 00 AM">08:00 AM</option>
                    <option value="09: 00 AM">09:00 AM</option>
                    <option value="10: 00 AM">10:00 AM</option>
                    <option value="11: 00 AM">11:00 AM</option>
                    <option value="12: 00 PM">12:00 PM</option>
                    <option value="01: 00 PM">01:00 PM</option>
                    <option value="02: 00 PM">02:00 PM</option>
                    <option value="03: 00 PM">03:00 PM</option>
                    <option value="04: 00 PM">04:00 PM</option>
                    <option value="05: 00 PM">05:00 PM</option>
                    <option value="06: 00 PM">06:00 PM</option>
                    <option value="07: 00 PM">07:00 PM</option>
                    <option value="08: 00 PM">08:00 PM</option>
                    <option value="09: 00 PM">09:00 PM</option>
                    <option value="10: 00 PM">10:00 PM</option>
                    <option value="11: 00 PM">11:00 PM</option>
                  </select>
                </div>
                <div className="form-group col-auto pr-0">
                  <select className="form-control" placeholder="To" onChange={(e) => handleChangehours(e, "to")} name="to" value={bizHours.to} aria-label="Default select example">
                    <option>Closing</option>
                    <option value="12: 00 AM">12:00 AM</option>
                    <option value="01: 00 AM">01:00 AM</option>
                    <option value="02: 00 AM">02:00 AM</option>
                    <option value="03: 00 AM">03:00 AM</option>
                    <option value="04: 00 AM">04:00 AM</option>
                    <option value="05: 00 AM">05:00 AM</option>
                    <option value="06: 00 AM">06:00 AM</option>
                    <option value="07: 00 AM">07:00 AM</option>
                    <option value="08: 00 AM">08:00 AM</option>
                    <option value="09: 00 AM">09:00 AM</option>
                    <option value="10: 00 AM">10:00 AM</option>
                    <option value="11: 00 AM">11:00 AM</option>
                    <option value="12: 00 PM">12:00 PM</option>
                    <option value="01: 00 PM">01:00 PM</option>
                    <option value="02: 00 PM">02:00 PM</option>
                    <option value="03: 00 PM">03:00 PM</option>
                    <option value="04: 00 PM">04:00 PM</option>
                    <option value="05: 00 PM">05:00 PM</option>
                    <option value="06: 00 PM">06:00 PM</option>
                    <option value="07: 00 PM">07:00 PM</option>
                    <option value="08: 00 PM">08:00 PM</option>
                    <option value="09: 00 PM">09:00 PM</option>
                    <option value="10: 00 PM">10:00 PM</option>
                    <option value="11: 00 PM">11:00 PM</option>yyyyyy
                  </select>
                </div>

                <span className="mb-3 col-auto pr-0" onClick={() => handleChange("", "businessHours")}><i className="fa fa-plus addSocialLinkBtn"></i></span>


              </div>
              {/* social media */}
              <span className='bold-semifont para mt-5 dib'>SOCIAL MEDIA</span>
              <div className='app-border-full'></div>
              {/* <div>
              <span>Facebook</span>
              <span>ahsaniqbal426</span>
              <span className="mb-3 col-auto"><i class="fa fa-plus addSocialLinkBtn"></i></span>
            </div> */}

              {socialMedia?.length > 0 ?
                socialMedia.map((b, index) => {
                  return (
                    <>
                      <div className="row ai-center" key={index}>
                        <div className="form-group col-auto pr-0">
                          <select className="form-control" style={{ textTransform: 'capitalize' }} disabled placeholder="Select Media" aria-label="Default select example">
                            <option value={b.media}>{b.media}</option>
                          </select>
                        </div>
                        <div className="form-group col pr-0">
                          <input className="form-control" placeholder="Social Media Link" disabled name="mediaLink" type="text" value={b.url}></input>
                        </div>
                        <span className="mb-3 col d-flex jcE" onClick={() => deleteItem(index, 'media')}><i className="fa fa-trash" aria-hidden="true"></i></span>

                      </div>
                    </>

                  )
                })
                : null}

              <div className="row ai-center">
                <div className="form-group col-auto pr-0">
                  <select className="form-control" placeholder="Select Media" onChange={(e) => handleChangeMedia(e, 'socialMedia')} name="socialMedia" value={socialMedia.media} aria-label="Default select example">
                    <option >Select Social Media</option>
                    <option value="facebook">Facebook</option>
                    <option value="twitter">Twitter</option>
                    <option value="instagram">Instagram</option>
                    <option value="youtube">Youtube</option>
                  </select>
                </div>
                <div className="form-group col pr-0">
                  <input className="form-control" placeholder="Social Media Link" name="mediaLink" type="text" onChange={(e) => handleChangeMedia(e, 'socialMediaUrl')} value={socialMedia.url}></input>
                </div>
                <span className="mb-3 col-auto" onClick={() => handleChange("", "socialMedia")}><i className="fa fa-plus addSocialLinkBtn"></i></span>
              </div>
              {/* description */}
              <span className='bold-semifont para mt-5 dib'>DESCRIPTION</span>
              <div className='app-border-full'></div>
              <div>
                <textarea className="form-control" placeholder="Description ..." name="description" onChange={(e) => setDescription(e.target.value)} value={description} rows="4" cols="50">
                </textarea>
              </div>

              {/* status */}
              <span className='bold-semifont para mt-5 dib'>STATUS</span>
              <div className='app-border-full'></div>
              <div>
                <label className="db">
                  <input className="" name="status" type="radio" onChange={(event) => handleChange(event, "status")} checked={status} value={true}></input>Active
                </label>
                <label className="db">
                  <input className="" name="status" type="radio" onChange={(event) => handleChange(event, "status")} checked={!status} value={false} ></input>Block
                </label>
              </div>


              {/* Images */}
              <span className='bold-semifont para mt-5 dib'>IMAGES</span>
              <div className='app-border-full'></div>
              <div>
                <p className="mb-1">Cover image</p>
                <input type="file" accept="image/x-png,image/jpeg" onChange={(e) => { onImageChange(e, 'cover'); }} placeholder="coverImage" />
                <p className="mb-1 mt-3">Business Logo</p>
                <input type="file" accept="image/x-png,image/jpeg" onChange={(e) => { onImageChange(e, 'logo'); }} placeholder="logoImage" />
              </div>

              {/* <hr /> */}

              <div className="form-group text-center mt-4">
                <Button className='round-button' type="submit">{isSubmit ? 'Please wait' : 'Save'}</Button>
              </div>

            </form>
          </div>
        </div>
      </div >

    </>
  )
}
export default AdminAddBusiness